module.exports = __webpack_public_path__ + "fromBrideToParents-we-w.c86bfe4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToParents-we-w.jpg
// module id = cs1Z
// module chunks = 0